var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_75859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 1.33325C6.68114 1.33325 5.3922 1.72425 4.29588 2.45679C3.19955 3.18933 2.34506 4.23052 1.84048 5.4487C1.3359 6.66687 1.20387 8.00731 1.46111 9.30052C1.71834 10.5937 2.35328 11.7816 3.28563 12.714C4.21798 13.6463 5.40587 14.2813 6.69908 14.5385C7.99228 14.7957 9.33273 14.6637 10.5509 14.1591C11.7691 13.6545 12.8103 12.8 13.5428 11.7037C14.2754 10.6074 14.6663 9.31846 14.6663 7.99992C14.6663 7.12444 14.4939 6.25753 14.1589 5.4487C13.8238 4.63986 13.3328 3.90493 12.7137 3.28587C12.0947 2.66682 11.3597 2.17575 10.5509 1.84072C9.74206 1.50569 8.87516 1.33325 7.99968 1.33325ZM7.99968 13.3333C6.94484 13.3333 5.9137 13.0205 5.03664 12.4344C4.15957 11.8484 3.47599 11.0154 3.07232 10.0409C2.66865 9.06636 2.56304 7.994 2.76882 6.95944C2.97461 5.92487 3.48256 4.97456 4.22844 4.22868C4.97432 3.4828 5.92463 2.97485 6.9592 2.76906C7.99376 2.56328 9.06612 2.66889 10.0407 3.07256C11.0152 3.47623 11.8481 4.15982 12.4342 5.03688C13.0202 5.91394 13.333 6.94509 13.333 7.99992C13.333 9.41441 12.7711 10.771 11.7709 11.7712C10.7707 12.7713 9.41417 13.3333 7.99968 13.3333Z",
    fill: "#FF4242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 11.3333C8.36786 11.3333 8.66634 11.0349 8.66634 10.6667C8.66634 10.2985 8.36786 10 7.99967 10C7.63148 10 7.33301 10.2985 7.33301 10.6667C7.33301 11.0349 7.63148 11.3333 7.99967 11.3333Z",
    fill: "#FF4242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 4.66675C7.82286 4.66675 7.65329 4.73699 7.52827 4.86201C7.40325 4.98703 7.33301 5.1566 7.33301 5.33341V8.66675C7.33301 8.84356 7.40325 9.01313 7.52827 9.13815C7.65329 9.26318 7.82286 9.33342 7.99967 9.33342C8.17649 9.33342 8.34605 9.26318 8.47108 9.13815C8.5961 9.01313 8.66634 8.84356 8.66634 8.66675V5.33341C8.66634 5.1566 8.5961 4.98703 8.47108 4.86201C8.34605 4.73699 8.17649 4.66675 7.99967 4.66675Z",
    fill: "#FF4242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_75859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionRed);
export default __webpack_public_path__ + "static/media/icon_question_red.2ca04af6be44c1d50c687bba40971102.svg";
export { ForwardRef as ReactComponent };